// Decorative hexagon grid background
export default function HexagonField({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      <svg className="absolute -top-20 -right-20 w-[720px] opacity-[0.07]"
           viewBox="0 0 200 200" fill="none">
        <defs>
          <pattern id="hex" patternUnits="userSpaceOnUse" width="24" height="28" patternTransform="rotate(0)">
            <polygon points="12,0 24,7 24,21 12,28 0,21 0,7" fill="none" stroke="white" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hex)" />
      </svg>
      <svg className="absolute -bottom-32 -left-20 w-[640px] opacity-[0.05]"
           viewBox="0 0 200 200" fill="none">
        <use href="#hex" />
        <rect width="100%" height="100%" fill="url(#hex)" />
      </svg>
    </div>
  );
}
